module.exports = __webpack_public_path__ + "static/media/tick.b3e285dc.svg";